import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Cancel ongoing content generation
 * @param {Object} state - Content state object
 * @param {Function} t - Translation function
 */
export const cancelGeneration = (state, t) => {
  try {
    if (state.cancelTokenSource?.value) {
      // Cancel the request
      state.cancelTokenSource.value.cancel('Content generation canceled by user')
      
      // Show user feedback
      if (t) {
        responseHandlerService.handleInfo(t('socialMedia.components.createPost.info.cancelGeneration'))
      } else {
        responseHandlerService.handleInfo('Content generation canceled')
      }
    }
  } catch (error) {
    console.error('Error canceling request:', error)
  } finally {
    // Reset state in any case
    state.isGenerating.value = false
    state.cancelTokenSource.value = null
  }
}
